import { byMedia } from '../helpers/media';
import { getPx } from '../helpers/common';
export const minWidth = byMedia(value => `min-width: ${getPx(value)};`);